<app-spinner></app-spinner>
<div [dir]="isRTL() ? 'rtl' : 'ltr'">
  <!-- Login Screen for authenticating user to access protected routes -->
  <app-login *ngIf="showLogin" (authenticated)="userAuthenticated()"></app-login>
  <router-outlet *ngIf="!showLogin"></router-outlet>
</div>
